<div class="modal" [class.open]="open">
    <div class="modal-content">
        <img [src]="image_url" alt="">
    </div>
</div>